import { LABELS } from "../global/constants";

export const DialogTitle =  ({ text=LABELS}) => {
    if ( !text ) {
        return '';
    } 

    return (
        <h3 className={ `h3 dialog__title` }>{text}</h3>
    )
}